import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { TransactionSaveBtn } from "../components/transactionSaveBtn";
import { CancelBtn } from "../components/cancelBtn";
import { useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
function EditTransaction() {

  const API_URL = process.env.REACT_APP_API_URL;

  const { id } = useParams();
  const [transaction, setTransaction] = useState({});
  const [fetchLoading, setFetchLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cancelClicked, setCancelClicked] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [originalAmount, setOriginalAmount] = useState(0);
  const [originalTip, setOriginalTip] = useState(0);

  const [formData, setFormData] = useState({
    datecreated: "",
    servicename: "",
    amount: "",
    username: "",
    tip:"",
    signature: "",
  });

  const navigate = useNavigate();

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({ mode: "onChange" });

  const sigCanvasRef = useRef(null);
  const [signatureBase64, setSignatureBase64] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/transactions/${id}`)
      .then((response) => {
        setFormData(response.data);
        setTransaction(response.data);
        setOriginalAmount(response.data.amount);
        setOriginalTip(response.data.tip);
        setSignatureBase64(response.data.signature);
        setFetchLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setFetchLoading(false);
      });
  }, [id, API_URL]);

  useEffect(() => {
    if (signatureBase64 && sigCanvasRef.current) {
      const canvas = sigCanvasRef.current.getCanvas();
      const context = canvas.getContext("2d");
      const image = new Image();

      image.onload = () => {
        const x = (canvas.width - image.width) / 2;
        const y = (canvas.height - image.height) / 2;
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, x, y);
      };

      image.src = signatureBase64.startsWith("data:image")
        ? signatureBase64
        : `data:image/png;base64,${signatureBase64}`;
    }
  }, [signatureBase64]);

  const getDateValue = (data) => {
    setStartDate(data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onDelete = async () => {
    const answer = window.confirm(
      `Are you sure you want to delete ${formData.servicename} transaction?`
    );
    const payload = {
      client_id: formData.client_id
    };
    if(answer){
      try{
        const response = await axios.delete(`${API_URL}/transactions/${id}`,{data: payload});
        if(response.data != null && !cancelClicked){
          alert("Transaction deleted successfully");
          navigate(`/clients/${formData.client_id}`);
        }
      }catch{
        setError("Something went wrong while deleting the transaction. Please try it again later");
        alert(error);
      }
    }

  }

  const onCancel = () => {
    setCancelClicked(true);
    navigate(`/clients/${formData.client_id}`);
  };

  const onSubmit = async (data,event) => {
    const action = event.nativeEvent.submitter.value;
    if(action !== "submit"){
      return;
    } else{
      try{
        setCancelClicked(false);
        setIsLoading(true);
        const payload = {
          ...formData,
          datecreated: startDate,
          originalAmount,
          originalTip,
        }
        const response = await axios.put(`${API_URL}/transactions/${payload.id}`,payload);
        if(response.data != null && !cancelClicked){
          alert(response.data.message);
          navigate(`/clients/${payload.client_id}`)
        }
      }catch{
        setError("Something went wrong while updating the transaction. Please try again later");
      }
    }
  };
  function parseMoney(str) {
    const cleanStr = str.replace(/[^\d.-]/g, "");
    const amount = parseFloat(cleanStr);
    return amount;
  }
  if (fetchLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div className="h-dvh w-full flex items-center flex-col bg-[#545454]">
      <title>Edit Transaction | HairBank</title>
      <div className="flex w-4/5 items-end text-center">
        <div className="w-full">
          <h1 className="text-[#eed495] text-6xl mt-16 xl:mt-5 w-full">
            Edit Transaction
          </h1>
        </div>
      </div>
      <div className="flex w-3/5 justify-end mt-14 ">
        <button onClick={onDelete} className="w-24 text-3xl text-white border-2 ">Delete</button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="w-3/5">
        <div className="flex border-2 flex-col h-auto justify-center">
          <div className="flex items-center ml-2">
            <div className="w-1/2 text-white text-lg">
              <label htmlFor="serviceName">Service:</label>
            </div>
            <div className="w-full">
              <input
                {...register("servicename", {
                  required: "Service name is required",
                })}
                name="servicename"
                required
                onChange={handleChange}
                type="text"
                defaultValue={transaction && transaction.servicename}
                className="w-full text-lg text-white bg-[#7a7a7a] focus:outline-none mt-2 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center ml-2">
            <div className="w-1/2 text-white text-lg">
              <label htmlFor="amount">Amount:</label>
            </div>
            <div className="w-full">
              <input
                {...register("amount", {
                  required: "Amount is required",
                })}
                name="amount"
                type="number"
                min="0.00"
                step="0.01"
                onChange={handleChange}
                defaultValue={transaction && parseMoney(transaction.amount)}
                className="w-full text-lg text-white bg-[#7a7a7a] focus:outline-none mt-2 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.amount?.message && (
            <div className="text-lg text-red-400 text-center">
              <span>{errors.amount?.message}</span>
            </div>
          )}
          <div className="flex items-center ml-2">
            <div className="w-1/2 text-white text-lg">
              <label htmlFor="tip">Tip:</label>
            </div>
            <div className="w-full">
              <input
                {...register("tip", {
                  required: "Tip is required",
                })}
                name="tip"
                type="number"
                min="0.00"
                step="0.01"
                onChange={handleChange}
                defaultValue={transaction && parseMoney(transaction.tip)}
                className="w-full text-lg text-white bg-[#7a7a7a] focus:outline-none mt-2 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.tip?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.tip?.message}</span>
            </div>
          )}
          <div className="flex items-center ml-2">
            <div className="w-1/2 text-white text-lg">
              <label htmlFor="dateCreated">Date:</label>
            </div>
            <div className="w-full">
              <input
                {...register("dateCreated", {
                  required: "Date is required",
                })}
                name="dateCreated"
                type="date"
                onChange={(e) => getDateValue(e.target.value)}
                defaultValue={
                  transaction && transaction.datecreated.split("T")[0]
                }
                className="w-full text-lg text-white bg-[#7a7a7a] focus:outline-none mt-2 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center ml-2">
            <div className="w-1/2 text-white text-lg">
              <label htmlFor="userName">User Name:</label>
            </div>
            <div className="w-full">
              <input
                {...register("username", {
                  required: "User Name is required",
                })}
                name="username"
                required
                type="text"
                onChange={handleChange}
                defaultValue={transaction && transaction.username}
                className="w-full text-lg text-white bg-[#7a7a7a] focus:outline-none mt-2 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>

          <div className="bg-gray">
            <SignatureCanvas
              ref={sigCanvasRef}
              penColor="black"
              canvasProps={{
                width: 400,
                height: 200,
                className: "sigCanvas mt-5 pointer-events-none",
              }}
            />
          </div>
        </div>
        <div className="flex justify-center gap-10">
          <TransactionSaveBtn
            canClick={isValid}
            isLoading={isLoading}
            actionText={"Save"}
            onClick={onSubmit}
          />
          <CancelBtn actionText={"Cancel"} onClick={onCancel} />
        </div>
      </form>
    </div>
  );
}

export default EditTransaction;
